export const LicenseAssignationModalStyles = {
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxWidth: "calc(100% - 20px)",
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  },
  searchField: {
    mb: 2,
  },
  noResultsText: {
    mt: 2,
  },
  button: {
    textTransform: "none",
  },
  userList: {
    width: "100%",
    bgcolor: "background.paper",
    maxHeight: 220,
    overflow: "auto",
  },
  confirmationPanel: {
    mt: 3,
    p: 2,
  },
  confirmationText: {
    mb: 1.5,
  },
  confirmationDivider: { my: 1.5 },
  confirmationLicenseBox: {
    mb: 2,
    p: 1,
    borderRadius: 1,
    bgcolor: "action.hover",
  },
  confirmationLicenseHeader: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    mb: 0.25,
  },
  confirmationWarningIcon: { fontSize: 14, color: "warning.main" },
} as const;
